<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>
<div class="container">
    <h1 class="title-default">Inteligência de Dados</h1>
    <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Inteligência de Dados</span>! Aqui tem todos os relatórios internos da empresa e suas configurações.</p>
    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
</div>
